<div *ngIf="!hidden" [ngClass]="{'pointer': clickHandler != null}"
  title="{{this.title != undefined ? this.title : clickHandler != null ? 'Visualizza dettagli' : ''}}">
  <div class="rounded-3 px-4 py-1 m-0 border" (click)="onClick()"
    [ngClass]="{'border-primary bg-primary text-white fw-bold': status, 'border-secondary text-secondary opacity-75': !status}">
    {{label}}
  </div>
</div>